import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { FilteredAzIpResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azIpColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("IP", "ip"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_ip"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  {
    field: "resource.is_in_use",
    headerName: "Status",
    cellRenderer: ({ data }: ICellRendererParams<FilteredAzIpResourceItem>) => {
      return data?.resource?.is_in_use ? "Attached" : "Unattached";
    },
  },
  { field: "resource.resource_group", headerName: "Resource Group" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
